'use client'

import React from 'react'
import { NavigationItemFragment } from '@productsite/src/graphql/generated/graphql-types'
import {
  default as Breadcrumbs,
  PathFragment,
} from '@dustin-web/microsite-components/src/breadcrumbs'
import { getCategoryUrl } from '@dustin-web/microsite-components/src/utils/urls'

type BreadcrumbsProps = {
  path: (NavigationItemFragment | { category: { name: string; pathSlug: string, seoLongTitleName: string } })[]
  shallow?: boolean
  productSpecifications?: string
  pageTitle?: string
}

const ProductsiteBreadcrumbs = ({
  path,
  shallow = false,
  pageTitle
}: BreadcrumbsProps) => {

  path = path.filter(p => p.category !== null)
  if (!path.length || !path[0].category) {
    return null
  }
  const route = '/group/[...categoryPath]'
  const pathParts = [
    {
      displayName: pageTitle ?? '',
      url: getCategoryUrl(path[0].category.pathSlug),
      clientNavigationRoute: route,
    },
    ...(path
      .slice(1)
      .map(p => {
        if (!p.category || !p.category.name) {
          return
        }

        return {
          displayName: p.category.seoLongTitleName || p.category.name,
          url: getCategoryUrl(p.category.pathSlug),
          clientNavigationRoute: route,
        }
      })
      .filter(Boolean) as PathFragment[]),
  ]
  return <Breadcrumbs path={pathParts} shallow={shallow} />
}

export default ProductsiteBreadcrumbs
